interface Props {
  space?: string;
}

export default function Spacer({ space = "10px" }: Props) {
  return <div style={{ marginTop: space }}></div>;
}
